<div class="flex items-center justify-center dialog-header ">
    {{type}} Dialing Group

    <div class="absolute right-2">
        <button (click)="handleCloseDialog()" class="outline-none p-5">
            <i class="pi pi-times"></i>
        </button>
    </div>

</div>

<div class="dialog-content">
    <div class="form-row row mt-0">
        <div class="form-group col-md-12 template-box">
            <label for="templateName">Group Name*</label>
            <input pInputText [(ngModel)]="group_name" name="group_name" #group_name_="ngModel"
                placeholder="Enter Group Name" class="w-full mb-1 mt-1" [required]="true"/>
            
            <div *ngIf="group_name_.errors && isSubmitted" class="errors">
                <div *ngIf="group_name_.errors['required']">Group name is required</div>
            </div>
        </div>
    </div>

    <div class="flex justify-end mt-4">
        <p-button [label]="'Save'" (click)="handleSaveGroup()" 
        [loading]="btnLoading"
        [disabled]="btnLoading"></p-button>
    </div>

</div>